import { render, staticRenderFns } from "./editFixedPurchase.vue?vue&type=template&id=3b2b4f42&scoped=true&"
import script from "./editFixedPurchase.vue?vue&type=script&lang=js&"
export * from "./editFixedPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2b4f42",
  null
  
)

export default component.exports